export const uniqueBy = <T, T2 extends keyof T>(
  sources: T[],
  key?: T2 | ((s: T) => string)
) => {
  return [
    ...new Map(
      sources.map((item) => [
        // @ts-ignore
        !key ? item : typeof key === 'function' ? key(item) : item[String(key)],
        item,
      ])
    ).values(),
  ];
};
